import { useEffect, useState } from 'react';

const useOnScreen = (ref: React.RefObject<Element>): boolean => {
    const [isOnScreen, setIsOnScreen] = useState(true);

    useEffect(() => {
        setIsOnScreen(false);
        const handleIntersection = (entries: IntersectionObserverEntry[]) => {
            const [entry] = entries;
            if (!entry.isIntersecting) return;
            setIsOnScreen(entry.isIntersecting);
        };

        const observer = new IntersectionObserver(handleIntersection, {
            root: null,
            rootMargin: '0px',
            threshold: 0.25,
        });

        const element = ref.current;
        if (element) {
            observer.observe(element);
        }

        return () => {
            if (element) {
                observer.unobserve(element);
            }
        };
    }, [ref]);

    return isOnScreen;
};

export default useOnScreen;